import { useState } from 'react'

type MenuItemType = {
  label: string
  onClick: () => void
}

export const useRecordsActions = (
  onMenuClose: () => void,
  initialState = false,
) => {
  const [isOpenBulkAddUpdate, setIsOpenBulkAddUpdate] = useState(initialState)
  const [isOpenBulkDelete, setIsOpenBulkDelete] = useState(initialState)
  const [isOpenLatestBatchJobStatus, setIsOpenLatestBatchJobStatus] =
    useState(initialState)

  const handleCsvBulkAddUpdate = () => {
    setIsOpenBulkAddUpdate(true)
    onMenuClose()
  }

  const handleCsvBulkDelete = () => {
    setIsOpenBulkDelete(true)
    onMenuClose()
  }

  const handleCheckLatestBatchJobStatus = () => {
    setIsOpenLatestBatchJobStatus(true)
    onMenuClose()
  }

  const closeCsvBulkAddUpdateDrawer = () => setIsOpenBulkAddUpdate(false)
  const closeCsvBulkDeleteDrawer = () => setIsOpenBulkDelete(false)
  const closeLatestBatchJobStatusDrawer = () =>
    setIsOpenLatestBatchJobStatus(false)

  const menuItems: MenuItemType[] = [
    {
      label: 'CSVで一括追加・更新',
      onClick: handleCsvBulkAddUpdate,
    },
    {
      label: 'CSVで一括削除',
      onClick: handleCsvBulkDelete,
    },
    {
      label: '一括処理状況の確認',
      onClick: handleCheckLatestBatchJobStatus,
    },
  ]

  return {
    menuItems,
    drawers: {
      bulkAddUpdate: {
        isOpen: isOpenBulkAddUpdate,
        close: closeCsvBulkAddUpdateDrawer,
      },
      bulkDelete: {
        isOpen: isOpenBulkDelete,
        close: closeCsvBulkDeleteDrawer,
      },
      latestBatchJobStatus: {
        isOpen: isOpenLatestBatchJobStatus,
        close: closeLatestBatchJobStatusDrawer,
      },
    },
  }
}
